import { GtmConsentSignal } from "cookiesConsent/infrastructure/gtm/GtmConsentSignal"

type ConsentCommand = [
  command: `consent`,
  action: `update` | `default`,
  state: Record<string, string>
]

declare global {
  interface Window {
    gtag?: (...args: ConsentCommand) => void
  }
}

export class GoogleTag {
  private last: GtmConsentSignal | null = null

  updateConsent = (signal: GtmConsentSignal): void => {
    if (this.last && this.last.equals(signal)) {
      this.ignore()
    } else {
      this.last = signal
      this.ensureGtag()
      window.gtag!(`consent`, `update`, signal.forGtm())
    }
  }

  private ensureGtag = (): void => {
    if (window.gtag) {
      this.ignore()
    } else {
      window.dataLayer = window.dataLayer || []
      // gtag.js only recognises consent commands pushed as an `arguments`
      // object; a plain array (`dataLayer.push([...])`) is treated as an
      // ordinary dataLayer message and silently dropped — which is why the
      // previous rest-param shim never actually reached Google Consent Mode.
      window.gtag = function gtag(): void {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments)
      }
    }
  }

  private ignore = (): void => {}

  // Test-only: clear the de-dupe state between specs.
  reset = (): void => {
    this.last = null
  }
}

export const googleTag = new GoogleTag()
